import { render, staticRenderFns } from "./NewsInformationDetail.vue?vue&type=template&id=3761d9f4&scoped=true&"
import script from "./NewsInformationDetail.vue?vue&type=script&lang=js&"
export * from "./NewsInformationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsInformationDetail.vue?vue&type=style&index=0&id=3761d9f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761d9f4",
  null
  
)

export default component.exports